import { Layout } from "providers/Layout";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { batchUploadCrumbs } from "../constants";
import { CsvUploadStatus } from "providers/ProgressContext/slices/UploadCsvSlice/types";
import { useProgressContext } from "providers/ProgressContext";

import Lottie from "lottie-react";
import lottieJson from "../lottie.json";

export const AnalyzingReport = () => {
  const { uploadCsv } = useProgressContext();
  return (
    <Layout
      headerClassName="pt-3"
      header={
        <div className="border-b border-alpha-100">
          <div className="mb-3 ml-6">
            <BreadCrumbs crumbs={batchUploadCrumbs} />
          </div>
        </div>
      }
    >
      <div className="animate-appear flex h-full flex-col items-center justify-center pb-20">
        <div className="max-w-[164px]">
          <Lottie animationData={lottieJson} loop />
        </div>
        <div className="w-full max-w-[360px]">
          <h1 className="mb-4 text-center text-base font-bold text-content-500">
            {uploadCsv.status === CsvUploadStatus.Parsing
              ? "Analyzing"
              : "Processing"}{" "}
            rent reporting CSV file...
          </h1>

          <p className="text-center text-sm font-medium text-content-300">
            This process may take up to 15 minutes. You can still use the
            platform in the meantime
          </p>
        </div>
      </div>
    </Layout>
  );
};
